// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".no_tasks[data-v-7b2753e0]{margin:1rem 0}", "",{"version":3,"sources":["webpack://./resources/client/modules/lead/sections/LeadTasks.vue"],"names":[],"mappings":"AAGA,2BACE,aAFF","sourcesContent":["\n@import \"../../../styles/variables/variables\";\n\n.no_tasks {\n  margin: 1rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
